import IconButton from '@material-ui/core/IconButton'
import CheckCircle from '@material-ui/icons/CheckCircle'
import EditIcon from '@material-ui/icons/Edit'

type EditScenarioProps = {
  toggle(): void
  isEditing: boolean
  submit(): void
}
///// Components
const EditScenario: React.FC<EditScenarioProps> = ({ toggle, submit, isEditing }) => {
  return (
    <IconButton onClick={isEditing ? submit : toggle} size='small'>
      {!isEditing ? <EditIcon /> : <CheckCircle />}
    </IconButton>
  )
}

export default EditScenario
